<template>
    <div style="max-width:100%" class="c-dashboard-day__parent"
        :data-component-name="$options.name"
    >
        <div class="c-dashboard-day__header"
            v-if="shiftsList.length>0 && showHeaders"
            v-html="headerDate"
        >
        </div>
        <div
            v-bind:key="shiftIndex" v-for="(shift, shiftIndex) in shiftsList"
            :class="[{ ' -collapsed' : currentShift!=shiftIndex}, 'c-dashboard-day', shift.state]"
            @click="currentShift=shiftIndex"
        ><!-- STATUS CLASS .-draft,.-published,.-alert,.-confirmed,.-completed -->
            <div class="c-dashboard-day__inner"
            >
                <div class="c-dashboard-day__stage">
                    <span class="u-text-to">
                        <span class="u-text-to-left u-text-truncate">{{ shift.name }}</span>
                        <span class="u-text-to-right">{{ shift.start_time }} à {{ shift.end_time }}</span>
                    </span>
                </div>

                <div class="o-shift-list__wrap">
                    <div class="o-shift-list -job">
                        <!-- <div v-if="shift.isDraft">
                            Brouillon
                        </div>
                        <div v-if="shift.hasDraftShift">
                            Possède un brouillon
                        </div> -->
                        <div v-if="!shift.professionList" class="o-shift-list__item">
                            <div class="o-shift-list__name">
                                <span class="o-shift-list__name__text">
                                    <q-icon name="warning" class="text-red" style="font-size: 1rem;" /> Aucune affectation
                                </span>
                            </div>
                        </div>


                        <div
                            v-if="shiftsView=='profession'"
                        >
                            <div
                                class="o-shift-list__item"
                                v-bind:key="pIndex" v-for="(profession, pIndex) in shift.professionList"
                                :class="profession.state"
                            >
                                <div class="o-shift-list__name">
                                    <span class="o-shift-list__name__text u-text-truncate">

                                        <q-icon name="hourglass_top" class="o-status-text -published" v-if="profession.state=='-published'"
                                            size="0.9rem"
                                        >
                                            <q-tooltip>
                                                <div v-html="profession.tooltipStr"></div>
                                            </q-tooltip>
                                        </q-icon>

                                        <q-icon name="warning" class="o-status-text" v-if="profession.state=='-alert'"
                                            size="0.9rem"
                                        >
                                            <q-tooltip>
                                                <div v-html="profession.tooltipStr"></div>
                                            </q-tooltip>
                                        </q-icon>

                                        <q-icon name="check_circle" class="o-status-text -completed" v-if="profession.state=='-completed'"
                                            size="0.9rem"
                                        >
                                        </q-icon>

                                        {{ profession.name }}
                                    </span>
                                </div>
                                <div class="o-shift-list__rate">{{ profession.assigned }} / {{ profession.total }}</div>
                            </div>
                        </div>

                        <div
                            v-if="shiftsView=='man'"
                        >
                            <div
                                class="o-shift-list__item"
                                v-bind:key="pIndex" v-for="(assignment, pIndex) in shift.assignments"
                                :class="{ 'is-alert': !assignment.assignedTo || assignment.hasAssignmentError || assignment.hasAbsenceError }"
                            >
                                <div class="o-shift-list__name">
                                    <span class="o-shift-list__name__text" v-if="!assignment.assignedTo">
                                        <q-icon name="o_assignment" class="o-status-text" 
                                            size="0.9rem"
                                        >
                                            <q-tooltip>
                                                Non assigné
                                            </q-tooltip>
                                        </q-icon>
                                         Non assigné
                                    </span>
                                    <span class="o-shift-list__name__text u-text-truncate" v-if="assignment.assignedTo">
                                        <q-menu
                                            touch-position
                                            context-menu
                                            v-if="assignment.__typename!='DraftAssignment' && myUserProfileRole=='ADMINISTRATOR'"
                                        >
                                            <q-list dense style="min-width: 100px">
                                                <q-item clickable v-close-popup
                                                    @click="acceptAssignment({ assignment: assignment, userProfileID: assignment.assignedTo.id, value: 'accept', reason: '' }, assignment.id)"
                                                >
                                                    <q-item-section>Accepter</q-item-section>
                                                    <q-item-section avatar>
                                                        <q-avatar size="sm" icon="thumb_up" color="green" text-color="white" />
                                                    </q-item-section>
                                                </q-item>
                                                <q-item clickable v-close-popup
                                                    @click="acceptAssignment({ assignment: assignment, userProfileID: assignment.assignedTo.id, value: 'deny', reason: '' }, assignment.id)"
                                                >
                                                    <q-item-section>Refuser</q-item-section>
                                                    <q-item-section avatar>
                                                        <q-avatar size="sm" icon="thumb_down" color="red" text-color="white" />
                                                    </q-item-section>
                                                </q-item>
                                                <q-item clickable v-close-popup
                                                    @click="acceptAssignment({ assignment: assignment, userProfileID: assignment.assignedTo.id, value: 'maybe', reason: '' }, assignment.id)"
                                                >
                                                    <q-item-section>Peut-être</q-item-section>
                                                    <q-item-section avatar>
                                                        <q-avatar size="sm" icon="help" color="blue" text-color="white" />
                                                    </q-item-section>
                                                </q-item>
                                            </q-list>
                                        </q-menu>
                                        <q-icon
                                            v-if="assignment.hasAssignmentError"
                                            name="event_busy"
                                            size="0.9rem"
                                            class="o-status-text -alert"
                                        >
                                            <q-tooltip>
                                                Cet employé est affecté à plus d'un quart de travail pour cette journée
                                            </q-tooltip>
                                        </q-icon>
                                        <q-icon
                                            v-else-if="assignment.hasAbsenceError"
                                            name="do_not_disturb_on_total_silence"
                                            size="0.9rem"
                                            class="o-status-text -alert"
                                        >
                                            <q-tooltip>
                                                Cet employé est absent cette journée
                                            </q-tooltip>
                                        </q-icon>
                                        <q-icon
                                            v-else-if="assignment.notification_pending"
                                            name="notifications"
                                            size="0.9rem"
                                            class="o-status-text -published"
                                        >
                                            <q-tooltip>
                                                Notification à envoyer
                                            </q-tooltip>
                                        </q-icon>
                                        <q-icon
                                            v-else-if="assignment.acceptedByUser"
                                            name="check_circle"
                                            size="0.9rem"
                                            class="o-status-text -completed"
                                        >
                                            <q-tooltip v-if="assignment.accepted_by">
                                                Accepté par {{ assignment.accepted_by.name }}
                                            </q-tooltip>
                                        </q-icon>
                                        <q-icon
                                            v-else-if="assignment.deniedByUser"
                                            name="warning_amber"
                                            size="0.9rem"
                                            class="o-status-text -alert"
                                        >
                                            <q-tooltip v-if="assignment.accepted_by">
                                                Refusée par {{ assignment.accepted_by.name }}
                                            </q-tooltip>
                                        </q-icon>
                                        <q-icon
                                            v-else-if="assignment.maybeByUser"
                                            name="help_outline"
                                            size="0.9rem"
                                            class="o-status-text -maybe"
                                        >
                                            <q-tooltip v-if="assignment.accepted_by">
                                                {{ assignment.accepted_by.name }} a répondu «Peut-être»
                                            </q-tooltip>
                                        </q-icon>
                                        <q-icon
                                            v-else-if="assignment.notification_sent"
                                            name="call_made"
                                            size="0.9rem"
                                            class="o-status-text -published"
                                        >
                                            <q-tooltip>
                                                En attente de confirmation
                                            </q-tooltip>
                                        </q-icon>
                                        <!-- {{ assignment.assignedTo.name }} -->
                                        <UserProfileInfo defaultTab="schedule" :scheduleScrollTo="assignment.date" :currentDate="assignment.date" :userProfile="assignment.assignedTo" :customContent="assignment.assignedTo.name" class="q-ml-xs" />

                                    </span>
                                </div>
                                <div class="o-shift-list__rate">{{ assignment.profession.shortname }}</div>
                                <div class="o-shift-list__rate">
                                    <UserProfileInfo
                                    defaultTab="schedule"
                                    :scheduleScrollTo="assignment.date"
                                    :currentDate="assignment.date"
                                    :userProfile="assignment.assignedTo"
                                    class="q-ml-xs" /></div>
                            </div>
                        </div>
                    </div>

                    <div class="o-shift-list__footer">
                        <div class="o-shift-list__item -controls">
                            <div class="o-shift-controls">
                                <div class="o-shift-hasMore-assignments" v-if="shiftsView=='man' && shift.assignments.length>6" @click="e => e.target.closest('.c-dashboard-row').classList.toggle('is-expanded')">
                                    <!-- <q-icon name="add" class="" /> -->
                                    <SvgIcon name="arrow-down" class="q-mr-xs" />
                                    +{{ shift.assignments.length - 5 }} affectations
                                </div>
                                <div class="o-shift-hasMore-assignments" v-else-if="shiftsView=='man' && shift.assignments.length>5" @click="e => e.target.closest('.c-dashboard-row').classList.toggle('is-expanded')">
                                    <!-- <q-icon name="add" class="" /> -->
                                    <SvgIcon name="arrow-down" class="q-mr-xs" />
                                    +{{ shift.assignments.length - 5 }} affectation
                                </div>
                                <div class="o-shift-hasMore-assignments" v-if="shiftsView=='profession' && shift.professionList && Object.keys(shift.professionList).length>6" @click="e => e.target.closest('.c-dashboard-row').classList.toggle('is-expanded')">
                                    <!-- <q-icon name="add" class="" /> -->
                                    <SvgIcon name="arrow-down" class="q-mr-xs" />
                                    +{{ Object.keys(shift.professionList).length - 5 }} metiers
                                </div>
                                <div class="o-shift-hasMore-assignments" v-else-if="shiftsView=='profession' && shift.professionList && Object.keys(shift.professionList).length>5" @click="e => e.target.closest('.c-dashboard-row').classList.toggle('is-expanded')">
                                    <!-- <q-icon name="add" class="" /> -->
                                    <SvgIcon name="arrow-down" class="q-mr-xs" />
                                    +{{ Object.keys(shift.professionList).length - 5 }} metier
                                </div>
                                <div class="o-shift-showLess-assignments" v-if="(shiftsView=='man' && shift.assignments.length>5) || (shiftsView=='profession' && shift.professionList && Object.keys(shift.professionList).length>5)" @click="e => e.target.closest('.c-dashboard-row').classList.toggle('is-expanded')">
                                    <SvgIcon name="arrow-up" class="q-mr-xs" />
                                    Réduire
                                </div>
                                <!-- <button class="o-shift-controls__item -clock">
                                    <SvgIcon name="clock" class="" />
                                </button>
                                <button class="o-shift-controls__item -notif is-toggle is-alert">
                                    <SvgIcon name="comment" class="-idle" />
                                    <SvgIcon name="comment-filled" class="-active" />
                                </button>
                                <button class="o-shift-controls__item -eye">
                                    <SvgIcon name="eye" class="" />
                                </button> -->
                            </div>
                            <button class="o-shift-controls__item -menu" v-if="!shift.isProjectShiftOverwriter">
                                <SvgIcon name="menu" class="" />
                                <q-menu>
                                    <q-list style="min-width: 100px">
                                        <div>
                                            <q-item clickable
                                                @click="createShiftOverride(shift)"
                                                v-close-popup
                                            >
                                                <q-item-section>Créer une exception</q-item-section>
                                            </q-item>
                                        </div>
                                    </q-list>
                                </q-menu>
                            </button>
                            <div v-else class="o-shift-controls__item">
                                <q-icon name="layers" size="16px" style="margin-top: 4px;margin-left: 6px;" class="is-override-icon">
                                    <q-tooltip>
                                        <div>Ce quart de travaille remplace le quart de travail «<strong>{{ shift.overwrittenProjectShift.name }}</strong>»</div>
                                    </q-tooltip>
                                </q-icon>
                            </div>
                        </div>
                    </div><!-- .o-shift-list__footer -->

                </div><!-- .o-shift-list__wrap -->

            </div><!-- .c-dashboard-day__inner -->
        </div><!-- .c-dashboard-day -->
    </div>
</template>

<script>
    import orderBy from "lodash/orderBy";
    import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
    import moment from 'moment';


    export default {
        name: 'Shift',
        props: {
            showHeaders: {
                type: Boolean,
                default: false,
            },
            headerDate: {
                type: String,
                default: ''
            },
            shifts: {
                type: Array,
                default: function(){
                    return new Array()
                }
            },
            draftShifts: {
                type: Array,
                default: function(){
                    return new Array()
                }
            },
            shiftsView: {
                type: String,
                default: 'profession'
            },
            myUserProfileRole: {
                type: String,
                default(){
                    return window.myUserProfileRole
                }
            },
            currentDate: {
                type: String,
                default: function(){
                    return moment(new Date()).format('YYYY/MM/DD')
                }
            }
        },
        data(){
            return {
                currentShift: 0
            }
        },
        mounted(){
        },
        computed: {
            shiftsList(){
                this.resetCurrentShift();
                this.shifts.forEach(function(shift){
                    shift.state="-completed";
                    shift.professionList=null;
                    shift.assignments=orderBy(shift.assignments, [item => item.profession.name.toLowerCase()])
                    let lastProfession=0, hasAlert=false, isNotCompleted=false;
                    shift.assignments.forEach(function(assignment){
                        let profID=assignment.profession.id;
                        if(profID!=lastProfession){
                            lastProfession=profID;
                            if(!shift.professionList) shift.professionList={};
                            shift.professionList[profID]={total: 0, assigned: 0, name: assignment.profession.name, state:"-completed", tooltips: [], tooltipStr: ""}
                        }
                        shift.professionList[profID].total++;
                        if(assignment.assignedTo){
                            shift.professionList[profID].assigned++;
                        }else{
                            shift.professionList[profID].state="-alert";
                            shift.professionList[profID].tooltips.push("Contient une affectation non assignée");
                            hasAlert=true;
                            shift.state="-alert"
                        }
                        if(assignment.deniedByUser){
                            hasAlert=true;
                            shift.state="-alert"
                            shift.professionList[profID].state="-alert";
                            shift.professionList[profID].tooltips.push(assignment.assignedTo.name +" a refusé son affectation");
                        }
                        
                        if(assignment.maybeByUser){
                            // hasAlert=true;
                            shift.state="-published"
                            shift.professionList[profID].state="-maybe";
                            shift.professionList[profID].tooltips.push(assignment.assignedTo.name +" a répondu «peut-être»");
                            isNotCompleted=true;
                        }

                        if(assignment.hasAssignmentError){
                            hasAlert=true;
                            shift.state="-alert"
                            shift.professionList[profID].state="-alert";
                            shift.professionList[profID].tooltips.push("Conflit d'horaire. "+assignment.assignedTo.name+" est assigné sur plus d'un quart de travail pour cette journée.");
                            isNotCompleted=true;
                        }
                        if(assignment.hasAbsenceError){
                            hasAlert=true;
                            shift.state="-alert"
                            shift.professionList[profID].state="-alert";
                            shift.professionList[profID].tooltips.push("Absence. "+assignment.assignedTo.name+" est absent cette journée.");
                            isNotCompleted=true;
                        }

                        if(assignment.notification_pending || assignment.notification_sent){
                            isNotCompleted=true;
                        }

                        if(isNotCompleted && shift.professionList[profID].state != "-alert"){
                            shift.professionList[profID].state="-published";
                            shift.professionList[profID].tooltips.push(" En attente d'approbation : "+assignment.assignedTo.name);
                        }

                        if(shift.isDraft) shift.professionList[profID].state="-draft";

                        if(shift.professionList[profID].tooltips.length>0) shift.professionList[profID].tooltipStr="• "+shift.professionList[profID].tooltips.join('<br>• ');
                    })

                    if(isNotCompleted){
                        shift.state="-published"
                    }
                    if(shift.assignments.length==0 || hasAlert) shift.state="-alert"
                    if(shift.isDraft) shift.state="-draft";
                    if(shift.hasDraftShift) shift.state="-hasdraft";
                    if(shift.state=="-alert"){
                        if(this.$parent?.$parent?.project?.status) this.$parent.$parent.project.status="alert"
                    }
                }.bind(this))
                return this.shifts
            }
        },
        methods: {
            resetCurrentShift(){
                this.currentShift=0;
            },
            createShiftOverride(shift){
                this.$emit('create-shift-override', shift);
            },
			acceptAssignment(option, assignmentID=null){
				if(option.reason) this.lastDenyReason=option.reason;
				this.noCacheUpdate=true;
				this.$apollo.mutate({
                    mutation: ACCEPTNOTIFICATIONASSIGNMENT,
                    variables: {
                        assignmentID: assignmentID,
                        userProfileID: option.userProfileID,
                        action: option.value,
                        message: option.reason,
                        // shiftsDateRange: {from: option.assignment.date , to: option.assignment.date},
                        page: 1,
						first: 1,
						result: true
                    }
				}).then(function(data){
                    this.$emit('refresh-project', data.data.acceptAssignment.data[0].project.id)
                    this.$eventBus.$emit('refresh-notifications', data.data.acceptAssignment.data[0].project.id);
					// let assignment=data.data.acceptAssignment.data[0];
					// this.userAssignments.data=this.userAssignments.data.filter(function(e){
					// 	return e.id!=assignment.id;
					// })
					// this.userAssignments.data.push(assignment)
					// this.userAssignments.data=this.userAssignments.data.concat( this.computeAssignments( {data: [assignment]} ) );
					// this.weekdays=this.computeWeekdays(this.userAssignments);
				}.bind(this))
				
			}
        }

    }
</script>

<style lang="scss" scoped>

</style>
